module.exports = __webpack_public_path__ + "img/pic04.2bf652b6.jpg";